import React from "react";
import "../../css/home/pop_up.css";
import { useNavigate } from "react-router-dom";

function PopUp() {
    const navigate = useNavigate();
    const handleLogoClick = () => {
        window.open("https://www.datechmarket.com/", "_blank");
    };
    return (
        <>
            <div className="popup-container">
                <div className="popup-content">
                    <div className="popup-text">
                        <h2>E-Ticaret Sitemiz Açıldı!</h2>
                        <p>
                            Web sitemizi ziyaret ederek ürünlerle ilgili detaylı bilgi alabilir, kampanyalardan faydalanabilirsiniz.
                        </p>
                    </div>
                    <div className="popup-buttons">
                        <button onClick={() => navigate("/contact")} className="button-primary">İletişim Bilgilerimiz</button>
                        <button onClick={handleLogoClick} className="button-secondary">Online Alışveriş</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PopUp;